import { isDevMode, NgModule } from '@angular/core';
import {
  ExtraOptions,
  provideRouter,
  RouterModule,
  Routes,
  withComponentInputBinding,
  withDebugTracing,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { MainViewComponent } from '@fantaz/shared/layout/main-view';
import { PageNotFoundComponent } from '@fantaz/tournaments/features/shell';

export const routes: Routes = [
  {
    path: '',
    component: MainViewComponent,
    data: {
      breadcrumb: {
        label: 'Home',
        href: '/?sh=true',
      },
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@fantaz/tournaments/features/shell').then(
            (m) => m.TournamentFeaturesShellModule,
          ),
      },
    ],
  },
  {
    path: 'gamehistory',
    component: MainViewComponent,
    data: {
      breadcrumb: {
        label: 'Home',
        href: '/?sh=true',
      },
    },
    loadChildren: () =>
      /* webpackChunkName: 'history' */ import(
        '@fantaz/game-history/features/shell'
      ).then((m) => m.GameHistoryFeaturesShellModule),
  },
  { path: 'not-found', pathMatch: 'full', component: PageNotFoundComponent },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent },
];

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

@NgModule({
  exports: [RouterModule],
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
      }),
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      ...(isDevMode() ? [withDebugTracing()] : []),
    ),
  ],
})
export class AppRoutingModule {}
